
import { useEffect } from "react";

import { useNavigate } from 'react-router-dom';

import { useAuth } from '@artegeie/mrc/context';
import { onLogin, onLogout } from '@artegeie/mona-sdk/auth'

import useTranslation from 'Hooks/useTranslation';

import 'scss/components/content/account.scss';

export default function AccountWelcome() {
	const { user } = useAuth();

	const navigate = useNavigate();

	const { t } = useTranslation();

	const { blogUrl } = window.appConfig;

	useEffect(() => {
		onLogout((detail) => {
			if (detail.kind === 'SSO_MONASDK_LOGOUT') {
				navigate( '/account-login', { trigger: true } );
			}
		});
		onLogin((detail) => {
			window.location.href = blogUrl
		});
	}, [] );


	return (

		<div id='account-page' className="account-welcome">

			<div id='login-container'>
				{user ? <p>{ t('account.welcome.hello') } {user.firstName} {user.lastName}.</p> : <div><p>{ t('account.welcome.hello') }</p><p>{ t('account.welcome.notLoggedIn') }</p></div>}
				<a href={blogUrl}>Home</a>
			</div>

		</div>
	);
};
